import { ControllerRenderProps } from "react-hook-form";
import React from "react";
import { useTranslation } from "react-i18next";
import { AppSelect, Option } from "@/components/ui/app-select";

// TODO move to shared
export const PlayerTimezoneSelect: React.FC<{
  field: ControllerRenderProps<any>;
  colorScheme?: 'blue' | 'purple' | 'green' | 'amber' | 'default';
}> = ({ field, colorScheme = 'blue' }) => {
  const { t } = useTranslation();
  // @ts-ignore
  const timezones = "supportedValuesOf" in Intl ? Intl.supportedValuesOf("timeZone") : [];

  const options: Option[] = timezones.map(
    (timezone: string) =>
      ({
        value: timezone,
        label: timezone,
      } satisfies Option)
  );

  return (
    <AppSelect
      value={field.value}
      onChange={field.onChange}
      options={options}
      placeholder={t("entities.timeZone")}
      label={t("entities.timeZone")}
      colorScheme={colorScheme}
    />
  );
};
